import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { EformService } from './service/eform.service';
import { IdleStateService } from './service/idle-state.service';
import { TestValueService } from './service/testvalue.service';
import { HelperTransalaterService } from './service/helper-translate.service';
import { Overlay } from '@angular/cdk/overlay';
import { MAT_LEGACY_AUTOCOMPLETE_SCROLL_STRATEGY } from '@angular/material/legacy-autocomplete';
import { FormsComponent } from './forms/forms.component';
import { FormComponent } from './form/form.component';
import { FormListComponent } from './form-list/form-list.component';
import { FormControlComponent } from './form-control/form-control.component';
import { GroupListComponent } from './dialog/group-list/group-list.component';
import { EformRoutingModule } from './e-from-routing.module';
import { FormCreateComponent } from './form-create/form-create.component';
import { SectionProPertiesComponent } from './form-control/properties/section-properties/section-properties.component';
import { TextboxPropertiesComponent } from './form-control/properties/textbox-properties/textbox-properties.component';
import { RestrictInputDirective } from './helper/directive/filterInput.directive';
import { AutofocusDirective } from './helper/directive/autofocus.directive';
import { FormGenerateComponent } from './form-generate/form-generate.component';
import { DynamicFormBuilderComponent } from './form-generate/dynamic-form-builder/dynamic-form-builder.component';
import { FieldBuilderComponent } from './form-generate/field-builder/field-builder.component';
import { TextboxComponent } from './form-generate/field-type/textbox/textbox.component';
import { RadioPropertiesComponent } from './form-control/properties/radio-properties/radio-properties.component';
import { RadioPipe } from './helper/pipe/radio.pipe';
import { ChoicePropertiesComponent } from './form-control/properties/choice-properties/choice-properties.component';
import { ChoiceLookupComponent } from './dialog/choice-lookup/choice-lookup.component';
import { CheckboxComponent} from './form-generate/field-type/checkbox/checkbox.component';
import { RadioComponent} from './form-generate/field-type/radio/radio.component';
import { ToggleComponent} from './form-generate/field-type/toggle/toggle.component';
import { NumberPropertiesComponent } from './form-control/properties/number-properties/number-properties.component';
import { DatePropertiesComponent } from './form-control/properties/date-properties/date-properties.component';
import { DateTime } from './helper/pipe/datetime.pipe';
import { ChoiceComponent } from './form-generate/field-type/choice/choice.component';
import { DropdownComponent } from './form-generate/field-type/dropdown/dropdown.component';
import { EmailPropertiesComponent } from './form-control/properties/email-properties/email-properties.component';
import { WebsitePropertiesComponent } from './form-control/properties/website-properties/website-properties.component';
import { PhonePropertiesComponent } from './form-control/properties/phone-properties/phone-properties.component';
import { CurrencyPropertiesComponent } from './form-control/properties/currency-properties/currency-properties.component';
import { DisplayValuePipe } from './helper/pipe/display-value.pipe';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { AddressPropertiesComponent } from './form-control/properties/address-properties/address-properties.component';
import { DateComponent } from './form-generate/field-type/date/date.component';
import { NumberComponent } from './form-generate/field-type/number/number.component';
import { SignaturePropertiesComponent } from './form-control/properties/signature-properties/signature-properties.component';
import { NamePropertiesComponent } from './form-control/properties/name-properties/name-properties.component';
import { UploadPropertiesComponent } from './form-control/properties/upload-properties/upload-properties.component';
import { PhoneNumberComponent } from './form-generate/field-type/phone-number/phone-number.component';
import { CurrencyComponent } from './form-generate/field-type/currency/currency.component';
import { EmailComponent } from './form-generate/field-type/email/email.component';
import { WebsiteComponent } from './form-generate/field-type/website/website.component';
import { FormTranslateComponent } from './dialog/form-translate/form-translate.component';
import { DeleteFormComponent } from './dialog/delete-form/delete-form.component';
import { MatLegacyPaginatorIntl as MatPaginatorIntl } from '@angular/material/legacy-paginator';
import { getPaginatorIntl } from './config/paginator-config';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import { AddressComponent } from './form-generate/field-type/address/address.component';
import { NameComponent } from './form-generate/field-type/name/name.component';
import { SignatureComponent } from './form-generate/field-type/signature/signature.component';
import { UploadComponent } from './form-generate/field-type/upload/upload.component';
import { ChoiceSetupComponent } from './dialog/choice-setup/choice-setup.component';
import { ClickStopPropagationDirective } from './helper/directive/stopEvent.directive';
import { EditDialogComponent } from './dialog/edit-dialog/edit-dialog.component';
import { NameCustomizeComponent } from './dialog/name-customize/name-customize.component';
import { TablePropertiesComponent } from './form-control/properties/table-properties/table-properties.component';
import { FormListDialogComponent } from './form-list-dialog/form-list-dialog.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DragulaModule} from 'ng2-dragula';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {MatLegacyChipsModule as MatChipsModule} from '@angular/material/legacy-chips';

import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { NumericOnlyInputDirective } from './helper/directive/numericOnlyInput.directive';
import { AllowOnlyBracketsInputDirective } from './helper/directive/allowOnlyBracketsInput.directive';
import { NoSpecialCharInputDirective } from './helper/directive/noSpecialCharInput.directive';
import { NumericOnlyInputWithLengthDirective } from './helper/directive/numericOnlyInputWithLegth.directive';
import { TableComponent } from './form-generate/field-type/table/table.component';


@NgModule({
   imports: [
      NgIdleKeepaliveModule.forRoot(),
      DragulaModule.forRoot(),
      DragDropModule,
      CommonModule,
      RouterModule,
      SharedModule,
      EformRoutingModule,
      FormsModule,
      ReactiveFormsModule,
      MatChipsModule,
      OwlDateTimeModule,
      OwlNativeDateTimeModule
   ],
   declarations: [
      FormsComponent,
      FormComponent,
      FormCreateComponent,
      FormListComponent,
      FormControlComponent,
      FormGenerateComponent,
      GroupListComponent,
      SectionProPertiesComponent,
      DynamicFormBuilderComponent,
      FieldBuilderComponent,
      TextboxPropertiesComponent,
      RestrictInputDirective,
      TextboxComponent,
      AutofocusDirective,
      RadioPropertiesComponent,
      RadioPipe,
      DateTime,
      ClickStopPropagationDirective,
      ChoicePropertiesComponent,
      ChoiceLookupComponent,
      CheckboxComponent,
      RadioComponent,
      ToggleComponent,
      NumberPropertiesComponent,
      DatePropertiesComponent,
      ChoiceComponent,
      DropdownComponent,
      EmailPropertiesComponent,
      WebsitePropertiesComponent,
      PhonePropertiesComponent,
      CurrencyPropertiesComponent,
      DisplayValuePipe,
      AddressPropertiesComponent,
      DateComponent,
      NumberComponent,
      SignaturePropertiesComponent,
      TablePropertiesComponent,
      NamePropertiesComponent,
      UploadPropertiesComponent,
      PhoneNumberComponent,
      CurrencyComponent,
      EmailComponent,
      WebsiteComponent,
      FormTranslateComponent,
      DeleteFormComponent,
      AddressComponent,
      NameComponent,
      SignatureComponent,
      UploadComponent,
      ChoiceSetupComponent,
      EditDialogComponent,
      NameCustomizeComponent,
      FormListDialogComponent,
      TableComponent,
      NumericOnlyInputDirective,
      AllowOnlyBracketsInputDirective,
      NoSpecialCharInputDirective,
      NumericOnlyInputWithLengthDirective,
   ], providers: [
      EformService, IdleStateService, TestValueService,
      {provide: MatPaginatorIntl, useFactory: getPaginatorIntl, deps: [TranslateService]},
      HelperTransalaterService,
      {
         provide: MAT_LEGACY_AUTOCOMPLETE_SCROLL_STRATEGY,
         useFactory: (overlay: Overlay) => () => overlay.scrollStrategies.close(),
         deps: [Overlay]
      }
   ]
   , exports: [
      DynamicFormBuilderComponent,
      FieldBuilderComponent,
      TextboxComponent,
   ]
})
export class EFormModule {
}
